import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCT_BATCHES_PATH } from '../../core/constants';

export const getProductBatchesAction = createAsyncThunk(
    'inventory/getProductBatchesAction',
    async (productId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRODUCT_BATCHES_PATH }?productId=${ productId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductBatchesSlice = createSlice({
    name: 'getProductBatchesSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateProductBatches() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getProductBatchesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductBatchesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductBatchesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateProductBatches } = getProductBatchesSlice.actions;
export const getProductBatchesState = (state) => state.inventory.getProductBatches;
export default getProductBatchesSlice.reducer;